<template>
  <div class="dropdown item">
    <button
      class="btn no-bg text-secondary dropdown-toggle filter"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i class="fas fa-filter"/>
      {{ $t('message.filter') }}
      <template>
        <span
          v-if="status == null"
          class="badge badge-secondary">{{ $t('message.all') }}</span>
        <span
          v-if="status == PENDING"
          class="badge badge-warning">{{ $t(`status.${docType}.pending`) }}</span>
        <span
          v-if="status == REJECTED"
          class="badge badge-danger">{{ $t(`status.${docType}.rejected`) }}</span>
        <span
          v-if="status == UNCOMPLETED"
          class="badge badge-info">{{ $t(`status.${docType}.uncompleted`) }}</span>
        <span
          v-if="status == COMPLETED"
          class="badge badge-success">{{ $t(`status.${docType}.completed`) }}</span>
      </template>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <form
        class="px-3 py-2"
        style="min-width: 300px;">
        <div class="form-group mb-0">
          <label>{{ $t('message.status') }}</label>
          <select
            class="form-control form-control-sm"
            @change="handleChange">
            <option :value="null">{{ $t('message.all') }}</option>
            <option
              :value="PENDING"
              class="text-warning">
              {{ $t(`status.${docType}.pending`) }}
            </option>
            <option
              :value="REJECTED"
              class="text-danger">
              {{ $t(`status.${docType}.rejected`) }}
            </option>
            <option
              :value="UNCOMPLETED"
              class="text-info">
              {{ $t(`status.${docType}.uncompleted`) }}
            </option>
            <option
              :value="COMPLETED"
              class="text-success">
              {{ $t(`status.${docType}.completed`) }}
            </option>
          </select>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { DOCUMENT_RPOCESS_STATUS } from '@/helpers/enum'

export default {
  props: {
    status: String,
    docType: String,
  },

  data () {
    return {
      PENDING: DOCUMENT_RPOCESS_STATUS.PENDING,
      UNCOMPLETED: DOCUMENT_RPOCESS_STATUS.UNCOMPLETED,
      COMPLETED: DOCUMENT_RPOCESS_STATUS.COMPLETED,
      REJECTED: DOCUMENT_RPOCESS_STATUS.REJECTED,
    }
  },

  methods: {
    handleChange (e) {
      if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
        $('button.filter').dropdown('toggle')
      }
      this.$emit('onSelect', e.target.value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseFilterDocProcessStatus.vue